import { EventStatus, MatchStatus } from '../types';

type StatusBadgeProps =
  | {
      kind: 'event';
      status: EventStatus;
    }
  | {
      kind: 'match';
      status: MatchStatus;
    };

const eventLabels: Record<EventStatus, { label: string; className: string }> = {
  approved: { label: 'Aprovado', className: 'badge-approved' },
  pending_review: { label: 'Em revisão', className: 'bg-warning text-dark' },
  changes_requested: { label: 'Ajustes solicitados', className: 'bg-info text-dark' },
  rejected: { label: 'Rejeitado', className: 'bg-danger text-white' },
  cancelled: { label: 'Cancelado', className: 'bg-secondary text-white' },
  merged: { label: 'Incorporado', className: 'bg-dark text-white border border-secondary' },
  draft: { label: 'Rascunho', className: 'bg-light text-dark' },
};

const matchLabels: Record<MatchStatus, { label: string; className: string }> = {
  pending_event_approval: { label: 'Aguardando aprovação', className: 'bg-secondary text-white' },
  sent: { label: 'Enviado', className: 'bg-warning text-dark' },
  viewed: { label: 'Visualizado', className: 'bg-info text-dark' },
  counter_proposed: { label: 'Contraproposta', className: 'bg-primary text-white' },
  accepted: { label: 'Aceito', className: 'badge-approved' },
  declined: { label: 'Recusado', className: 'bg-danger text-white' },
  expired: { label: 'Expirado', className: 'bg-secondary text-white' },
  converted: { label: 'Convertido', className: 'badge-approved' },
};

const StatusBadge = (props: StatusBadgeProps) => {
  const token = props.kind === 'event' ? eventLabels[props.status] : matchLabels[props.status];

  return <span className={`badge ${token.className}`}>{token.label}</span>;
};

export default StatusBadge;
